import { cn } from '@/platform/lib/utils';

const TableFooter = ({ className, children, ...props }) => (
    <tfoot
        className={cn(
            'border-t border-gray-200 bg-gray-50 font-medium text-gray-900',
            className
        )}
        {...props}
    >
        {children}
    </tfoot>
);

export default TableFooter;
